export const getFontSize = (title) => {
    const fontSizes = {
        h1: 26,
        h2: 22,
        h3: 14,
        h4: 13,
        h5: 12,
        h6: 11,
    };
    return fontSizes[title];
};
const titleTypes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export function getTitleTag(props) {
    for (const title of titleTypes) {
        if (props[title]) {
            return title;
        }
    }
}
